import { EyeOff, Target, Truck, Users } from "lucide-react";
import { FilterLiveForm, useGetIdentity, useTranslate } from "ra-core";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";
import { SearchInput } from "@/components/admin/search-input";

import { FilterCategory } from "../filters/FilterCategory";
import { ResetFiltersButton } from "../filters/ResetFiltersButton";
import { useConfigurationContext } from "../root/ConfigurationContext";

export const CompanyListFilter = () => {
  const { identity } = useGetIdentity();
  const { companySectors } = useConfigurationContext();
  const translate = useTranslate();
  return (
    <div className="w-52 min-w-52 flex flex-col gap-8">
      <ResetFiltersButton defaults={{ hidden: false, contact_blocked: false, is_private: false, is_customer: true }} />
      <FilterLiveForm>
        <SearchInput source="q" />
      </FilterLiveForm>

      <FilterCategory icon={<Target className="h-4 w-4" />} label="Akquise">
        {[
          ["hot", "Hot"],
          ["warm", "Warm"],
          ["cold", "Cold"],
        ].map(([value, label]) => (
          <ToggleFilterButton
            className="w-full justify-between"
            label={label}
            key={value}
            value={{ lead_score: value }}
          />
        ))}
      </FilterCategory>

      <FilterCategory
        icon={<Truck className="h-4 w-4" />}
        label="resources.companies.fields.sector"
      >
        {companySectors.map((sector) => (
          <ToggleFilterButton
            className="w-full justify-between"
            label={sector.label}
            key={sector.value}
            value={{ sector: sector.value }}
          />
        ))}
      </FilterCategory>

      <FilterCategory icon={<EyeOff className="h-4 w-4" />} label="Sichtbarkeit">
        <ToggleFilterButton
          className="w-full justify-between"
          label="Ausgeblendete anzeigen"
          value={{ hidden: true }}
        />
        <ToggleFilterButton
          className="w-full justify-between"
          label="Nur Kontaktsperre"
          value={{ contact_blocked: true }}
        />
        <ToggleFilterButton
          className="w-full justify-between"
          label="Privat & intern anzeigen"
          value={{ is_private: true }}
        />
      </FilterCategory>

      <FilterCategory
        icon={<Users className="h-4 w-4" />}
        label="resources.companies.fields.sales_id"
      >
        <ToggleFilterButton
          className="w-full justify-between"
          label={translate("crm.common.me")}
          value={{ sales_id: identity?.id }}
        />
      </FilterCategory>
    </div>
  );
};
